import React from "react";
import { AlertTriangle, Check } from "lucide-react";

export default function ReservationsAmbiguousPicker({ candidates, value, onChange }) {
  if (!candidates?.length) { return null; }
  return (
    <div className="rounded-xl border border-amber-300 bg-amber-50 p-3 space-y-2" data-testid="booking-ambiguous-picker">
      <div className="flex items-start gap-2 text-sm text-amber-900">
        <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0" />
        <span>Più clienti CRM hanno questo numero. Scegli quello corretto prima di confermare.</span>
      </div>
      {candidates.map((c) => {
        const active = value === c.id;
        return (
          <button key={c.id} type="button" onClick={() => onChange(c.id)}
                  data-testid={`booking-ambiguous-option-${c.id}`}
                  className={`w-full text-left rounded-lg border px-3 py-2 flex items-center justify-between transition-colors ${
                    active ? "border-ink-900 bg-white" : "border-amber-200 bg-white/70 hover:border-amber-400"}`}>
            <span className="min-w-0">
              <span className="block text-sm font-medium text-ink-900 truncate">
                {[c.name, c.surname].filter(Boolean).join(" ") || "Senza nome"}
              </span>
              <span className="block text-xs text-ink-500 truncate">{c.phone}{c.email ? ` · ${c.email}` : ""}</span>
            </span>
            {active && <Check className="w-4 h-4 text-ink-900 shrink-0" />}
          </button>
        );
      })}
    </div>
  );
}
